export interface ReceiveManifestNavigationState {
  tripId?: string;
  legStatus?: string;
  legDestination?: string;
}

export function resolveReceiveManifestNavigationContext(state?: ReceiveManifestNavigationState, search = '') {
  const queryParams = new URLSearchParams(search);

  return {
    tripId: state?.tripId || queryParams.get('tripId') || '',
    legStatus: state?.legStatus || queryParams.get('legStatus') || '',
    legDestination: state?.legDestination || queryParams.get('legDestination') || ''
  };
}
